import { Link } from 'react-router-dom';

const categoryImages: Record<string, string> = {
  hotel: 'https://readdy.ai/api/search-image?query=Luxury%20Macau%20hotel%20suite%20with%20elegant%20warm%20golden%20lighting%2C%20cream%20silk%20bedding%2C%20floor%20to%20ceiling%20windows%20overlooking%20city%2C%20asian%20luxury%20interior%20design%2C%20stylized%20editorial%20photography%2C%20soft%20ambient%20light%2C%20harmonious%20composition%2C%20clean%20background&width=600&height=800&seq=category-hotel-01&orientation=portrait',
  dining: 'https://readdy.ai/api/search-image?query=Elegant%20fine%20dining%20restaurant%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20crystal%20chandeliers%2C%20white%20tablecloth%2C%20asian%20luxury%20aesthetic%2C%20stylized%20editorial%20photography%2C%20soft%20cream%20tones%2C%20harmonious%20composition&width=600&height=800&seq=category-dining-01&orientation=portrait',
  entertainment: 'https://readdy.ai/api/search-image?query=Spectacular%20water%20fountain%20show%20at%20night%20with%20colorful%20lights%20and%20fire%20effects%2C%20grand%20luxury%20resort%20backdrop%2C%20dramatic%20lighting%2C%20stylized%20artistic%20photography%2C%20warm%20and%20cool%20light%20contrast%2C%20cinematic%20composition&width=600&height=800&seq=category-entertainment-01&orientation=portrait',
  shopping: 'https://readdy.ai/api/search-image?query=Luxury%20shopping%20mall%20interior%20with%20marble%20floors%20and%20golden%20accents%2C%20high%20end%20boutique%20storefronts%2C%20elegant%20warm%20lighting%2C%20asian%20luxury%20aesthetic%2C%20stylized%20editorial%20photography%2C%20soft%20cream%20tones%2C%20clean%20composition&width=600&height=800&seq=category-shopping-01&orientation=portrait',
  travel: 'https://readdy.ai/api/search-image?query=Historic%20Macau%20cityscape%20with%20traditional%20Portuguese%20architecture%20and%20modern%20skyline%2C%20warm%20sunset%20golden%20light%2C%20cobblestone%20streets%2C%20stylized%20travel%20photography%2C%20soft%20atmospheric%20haze%2C%20harmonious%20composition&width=600&height=800&seq=category-travel-01&orientation=portrait',
};

const categories = [
  {
    slug: 'hotel',
    name: '酒店预订',
    description: '探索永利皇宫极致奢华客房与套房，享受宫殿级住宿体验',
    icon: 'ri-hotel-line',
  },
  {
    slug: 'dining',
    name: '餐厅推荐',
    description: '品味米其林星级美馔，开启环球美食之旅',
    icon: 'ri-restaurant-line',
  },
  {
    slug: 'entertainment',
    name: '娱乐体验',
    description: '感受世界级娱乐表演与休闲设施，尽享欢乐时光',
    icon: 'ri-movie-line',
  },
  {
    slug: 'shopping',
    name: '购物指南',
    description: '畅游顶级品牌旗舰店，体验奢华购物之旅',
    icon: 'ri-shopping-bag-line',
  },
  {
    slug: 'travel',
    name: '旅游攻略',
    description: '获取澳门深度游攻略，规划完美度假行程',
    icon: 'ri-compass-line',
  },
];

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            探索永利
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            选择您的体验主题
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-lg mx-auto">
            根据您的兴趣，选择适合的主题深入了解永利皇宫的方方面面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer"
            >
              <img
                src={categoryImages[category.slug]}
                alt={`永利皇宫${category.name}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm mb-3">
                  <i className={`${category.icon} text-white text-lg`}></i>
                </div>
                <h3 className="font-heading text-white text-lg font-semibold mb-1">
                  {category.name}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed">
                  {category.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}